import axios from 'axios'
import { Notification } from 'element-ui'
import { getStore, removeStore } from '/utils/storage'

axios.defaults.headers['Content-Type'] = 'application/json'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.BASE_API,
  // 超时
  timeout: 50000
})
// request拦截器
service.interceptors.request.use(config => {
  // 是否需要设置 token
  if (getStore('hht-pc-token')) {
    config.headers['token'] = getStore('hht-pc-token') // 让每个请求携带自定义token 请根据实际情况自行修改
  }

  // get请求映射params参数
  if (config.method === 'get' && config.params) {
    let url = config.url + '?'
    for (const propName of Object.keys(config.params)) {
      const value = config.params[propName]
      var part = encodeURIComponent(propName) + '='
      if (value !== null && typeof (value) !== 'undefined') {
        if (typeof value === 'object') {
          for (const key of Object.keys(value)) {
            let params = propName + '[' + key + ']'
            var subPart = encodeURIComponent(params) + '='
            url += subPart + encodeURIComponent(value[key]) + '&'
          }
        } else {
          url += part + encodeURIComponent(value) + '&'
        }
      }
    }
    url = url.slice(0, -1)
    config.params = {}
    config.url = url
  }
  return config
}, error => {
  console.log(error)
  Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
  if (res.data.code !== 0) {
    if (res.data.code === 1001 || res.data.code === 1007) {
      removeStore('hht-pc-token')
      location.href = '/login'
    } else {
      Notification.error({
        title: '错误',
        message: res.data.error
      })
    }
    return Promise.reject(new Error(res.data.error))
  } else {
    return res.data.obj === undefined ? {} : res.data.obj
  }
},
error => {
  Notification.error({
    title: '请求超时'
  })
  return Promise.reject(new Error(error))
})

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js